import { Component } from '@angular/core';
// import { IHeaderAngularComp } from 'ag-grid-angular';
// import { IHeaderParams } from 'ag-grid-community';
// import { HeaderService } from 'app/pages/header/header.service';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss']
})
export class CustomHeaderComponent implements ITooltipAngularComp {
  public params: ITooltipParams;
  agInit(params: ITooltipParams): void {
    console.log('params', params);
    this.params = params;
  }

}
